import * as zod from 'zod';

import { Step } from '@sb/remote-control/types';

export namespace RunInBackgroundStep {
  export const name = 'Run in background';
  export const description =
    'Run substeps in the background while also continuing with the steps immediately after this block';
  export const isDecorator = true;
  export const librarySection = Step.LibrarySection.Control;
  export const argumentKind = 'RunInBackground';

  export const Arguments = zod.object({
    argumentKind: zod.literal(argumentKind),
  });

  export type Arguments = zod.infer<typeof Arguments>;

  export const toRoutineRunner: Step.ToRoutineRunner = ({
    stepConfiguration: { args },
    stepData,
  }) => {
    if (args?.argumentKind !== argumentKind) {
      throw new TypeError(`Expected argument kind ${argumentKind}`);
    }

    return {
      ...stepData,
      stepKind: 'RunInBackground',
      args: {},
    };
  };
}

RunInBackgroundStep satisfies Step.StepKindInfo;
